import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
export function LocalLaunch() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 lg:py-48 bg-texture-espresso text-cream border-y border-cream/5" data-id="element-240" data-mp="14cvre3be2mp7">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-241" data-mp="zdsn4l38gkia">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-6" data-id="element-242" data-mp="1wz6ubkmgwzp6">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-243" data-mp="bnf39husxrys">
            <span className="w-10 h-px bg-caramel/40" data-id="element-244" data-mp="6n0shs1tg3x2" />
            {t.localLaunch.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-245" data-mp="ys66n4dns4yl">
            {t.localLaunch.title1}
            <br data-id="element-246" data-mp="osxd2cmpgscr" />
            <span className="italic font-extralight" data-id="element-247" data-mp="otgk2yathwc0">
              {t.localLaunch.title2}
            </span>
          </h2>
          <p className="mt-10 text-cream/60 leading-[1.8] text-[15px] max-w-md" data-id="element-248" data-mp="tq70xnug4vyh">
            {t.localLaunch.copy}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.15
      }} className="lg:col-span-6" data-id="element-249" data-mp="kqtpipmrhxb4">
          <div className="relative" data-id="element-250" data-mp="12uqgc1k8elj">
            <div className="absolute -inset-2 border border-cream/10" aria-hidden data-id="element-251" data-mp="11t1r4rmftlc" />
            <div className="relative h-64 lg:h-80 bg-chocolate/60 border border-cream/10 overflow-hidden" data-id="element-252" data-mp="23r2rzgpfwev9">
              <img src={IMAGES.tablescape} alt="Three TARTA boxes beside fresh flowers — one open to reveal the cheesecake — in soft morning light" className="absolute inset-0 w-full h-full object-cover" data-id="element-253" data-mp="1ywyjgt0izys2" />
              <div className="absolute inset-0 pointer-events-none" aria-hidden style={{
              background: 'linear-gradient(to top, rgba(31,21,15,0.55), transparent 55%)'
            }} data-id="element-254" data-mp="2mnazys9u73u9" />
              <span className="absolute bottom-4 left-6 text-[10px] tracking-[0.3em] uppercase text-cream/80" data-id="element-255" data-mp="28nt5bw9v0wcz">
                30°12′N — 95°45′W
              </span>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-8" data-id="element-256" data-mp="x96546mzi89q">
              {t.localLaunch.points.map(p => <div key={p.label} data-id="element-257" data-mp="38xua4krlxfob">
                  <p className="text-[10px] tracking-[0.3em] uppercase text-cream/40 mb-3" data-id="element-258" data-mp="38yvujfuijeip">
                    {p.label}
                  </p>
                  <p className="font-serif text-xl text-cream font-light" data-id="element-259" data-mp="3hx7itb7wq07z">
                    {p.value}
                  </p>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}